import { t } from "i18next"

export function getBaseForm(): any {
    return {
        "page": {
            "body": {
                "container": {
                    "style": {
                        "background-color": "#FFFFFF"
                    }
                },
                "content": {
                    "computedStyle": {
                        "linkColor": "#0000FF",
                        "messageBackgroundColor": "transparent",
                        "messageWidth": "600px"
                    },
                    "style": {
                        "color": "#000000",
                        "font-family": "Arial, Helvetica Neue, Helvetica, sans-serif"
                    }
                },
                "type": "mailup-bee-page-properties",
                "webFonts": [
                    {
                        "fontFamily": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        "name": "Arial",
                        "url": ""
                    }
                ]
            },
            "description": "",
            "rows": [
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false
                                        },
                                        "heading": {
                                            "style": {
                                                "color": "#555555",
                                                "direction": "ltr",
                                                "font-family": "inherit",
                                                "font-size": "23px",
                                                "font-weight": "700",
                                                "letter-spacing": "0px",
                                                "line-height": "120%",
                                                "link-color": "#0000FF",
                                                "text-align": "center"
                                            },
                                            "text": `<span class=\"tinyMce-placeholder\">${t("form-default-content-title")}</span>`,
                                            "title": "h1"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "text-align": "center",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-heading",
                                    "uuid": "8c3ec444-f9c2-4989-ad90-e08c741d163d"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0000FF",
                                                "paragraphSpacing": "16px"
                                            },
                                            "html": `<p>${t("form-default-content-desc")}</p>`,
                                            "style": {
                                                "color": "#000000",
                                                "direction": "ltr",
                                                "font-family": "inherit",
                                                "font-size": "14px",
                                                "font-weight": "400",
                                                "letter-spacing": "0px",
                                                "line-height": "120%",
                                                "text-align": "left"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "ec28ef75-575a-4062-a9bc-df705fb5c92f"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center",
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false
                                        },
                                        "form": {
                                            "structure": {
                                                "attributes": {
                                                    "accept-charset": "UTF-8",
                                                    "action": "",
                                                    "autocomplete": "on",
                                                    "enctype": "multipart/form-data",
                                                    "method": "post",
                                                    "novalidate": false,
                                                    "target": "_self"
                                                },
                                                "description": "",
                                                "fields": {
                                                    "email": {
                                                        "attributes": {
                                                            "required": true
                                                        },
                                                        "canBeModified": true,
                                                        "canBeRemovedFromLayout": false,
                                                        "label": "Email",
                                                        "options": null,
                                                        "removeFromLayout": false,
                                                        "type": "email"
                                                    },
                                                    "submit_button": {
                                                        "attributes": {
                                                            "name": "submit_button",
                                                            "value": "Submit"
                                                        },
                                                        "canBeModified": true,
                                                        "canBeRemovedFromLayout": false,
                                                        "options": null,
                                                        "removeFromLayout": false,
                                                        "type": "submit"
                                                    },
                                                },
                                                "layout": [
                                                    [
                                                        "email"
                                                    ],
                                                    [
                                                        "submit_button"
                                                    ]
                                                ],
                                                "title": ""
                                            },
                                            "style": {
                                                "buttons": {
                                                    "backgroundColor": "#3AAEE0",
                                                    "border-bottom": "0px solid transparent",
                                                    "border-left": "0px solid transparent",
                                                    "border-radius": "4px",
                                                    "border-right": "0px solid transparent",
                                                    "border-top": "0px solid transparent",
                                                    "color": "#ffffff",
                                                    "font-style": "",
                                                    "font-weight": "",
                                                    "letter-spacing": "0",
                                                    "line-height": "200%",
                                                    "max-width": "100%",
                                                    "outer": {
                                                        "padding-bottom": "0px",
                                                        "padding-left": "0px",
                                                        "padding-right": "0px",
                                                        "padding-top": "0px"
                                                    },
                                                    "padding-bottom": "5px",
                                                    "padding-left": "20px",
                                                    "padding-right": "20px",
                                                    "padding-top": "5px",
                                                    "text-align": "center",
                                                    "width": "100%"
                                                },
                                                "fields": {
                                                    "backgroundColor": "#ffffff",
                                                    "border-bottom": "1px solid transparent",
                                                    "border-left": "1px solid transparent",
                                                    "border-radius": "4px",
                                                    "border-right": "1px solid transparent",
                                                    "border-top": "1px solid transparent",
                                                    "color": "#000000",
                                                    "outlineColor": "#3AAEE0",
                                                    "padding-bottom": "5px",
                                                    "padding-left": "5px",
                                                    "padding-right": "5px",
                                                    "padding-top": "5px"
                                                },
                                                "labels": {
                                                    "color": "#000000",
                                                    "font-style": "",
                                                    "font-weight": "",
                                                    "label-position": "top",
                                                    "letter-spacing": "0",
                                                    "line-height": "200%",
                                                    "min-width": "0",
                                                    "text-align": "left"
                                                }
                                            }
                                        },
                                        "style": {
                                            "background-color": "transparent",
                                            "font-family": "inherit",
                                            "font-size": "14px",
                                            "font-weight": "400",
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-form",
                                    "uuid": "42db8494-6274-4a9f-a1a9-6ba8a521d42c"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "c24a17bb-f999-4152-bb65-99a874c5cef2"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            "color": "#000000",
                            "padding-bottom": "0px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "0px",
                            "width": "600px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "",
                    "uuid": "37ca22fd-a005-46f6-86fa-44d398fb03f6"
                }
            ],
            "template": {
                "name": "template-base",
                "type": "basic",
                "version": "2.0.0"
            },
            "title": ""
        },
        "comments": {

        }
    }
}